import { Container, Grid } from "@mui/material";
import { Divider } from "antd";
import React, { Component } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { PostData } from "../api/service";
import { Typography } from "@material-ui/core";
import FacultyAchivement from "./KnowYourFaculty/FacultyAchivement";

const handleDragStart = (e) => e.preventDefault();

export default class Hightlights extends Component {
  state = {
    loadedData: [],
    isLoaded: false,
  };

  componentDidMount() {
    PostData(`/getphotosforwebsitewithcaption`, {
      type: "HIGHLIGHTS",
    }).then((resp) => {
      this.setState({
        loadedData: resp,
        isLoaded: true,
      });
    });
  }

  renderSlider(type) {
    return (
      <AliceCarousel
        autoPlay
        infinite
        autoPlayInterval={3000}
        mouseTracking
        buttonsDisabled
        dotsDisabled
        items={this.state.loadedData
          .filter((el) => el.type === type)
          .map((el, index) => (
            <div className="card" key={index}>
              
              <div className="img-box">
                <img
                  src={el.url}
                  onDragStart={handleDragStart}
                  className="img"
                />

                {/* Overlay Caption */}
                <div className="overlay">
                  <Typography className="overlay-text">
                    {el.caption}
                  </Typography>
                </div>
              </div>

            </div>
          ))}
      />
    );
  }

  renderSection(title, type) {
    if (
      this.state.loadedData.filter((el) => el.type === type).length === 0
    )
      return null;

    return (
      <div className="section">
        
        {/* MODERN DIVIDER */}
        <div className="title">
          <span>{title}</span>
        </div>

        <Container>{this.renderSlider(type)}</Container>
      </div>
    );
  }

  render() {
    return (
      <div className="wrapper">
        {this.state.isLoaded && (
          <Grid container spacing={3}>
            
            {/* <Grid item xs={12} md={3}>
              <FacultyAchivement />
            </Grid> */}

            <Grid item xs={12} md={4}>
              {this.renderSection("RESEARCH HIGHLIGHTS", "RESEARCH_HIGHLIGHTS")}
            </Grid>

            <Grid item xs={12} md={4}>
              {this.renderSection("NCC HIGHLIGHTS", "NCC_HIGHLIGHTS")}
            </Grid>

            <Grid item xs={12} md={4}>
              {this.renderSection("NSS HIGHLIGHTS", "NSS_HIGHLIGHTS")}
            </Grid>

          </Grid>
        )}

        {/* ================= CSS ================= */}
        <style jsx>{`
          .wrapper {
            padding: 30px 15px;
            background: #f4f6f7;
            animation: fadeIn 1s ease-in;
          }

          /* SECTION TITLE */
          .title {
            text-align: center;
            margin-bottom: 15px;
            position: relative;
          }

          .title span {
            font-weight: 700;
            font-size: 16px;
            color: #1e3760;
            background: #f4f6f7;
            padding: 0 10px;
            position: relative;
            z-index: 2;
          }

          .title::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            background: #d5d8dc;
            z-index: 1;
          }

          /* CARD */
          .card {
            padding: 5px;
          }

          .img-box {
            position: relative;
            overflow: hidden;
            border-radius: 12px;
            height: 300px;
          }

          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.4s;
          }

          /* OVERLAY */
          .overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.75),
              rgba(0, 0, 0, 0.1)
            );
            opacity: 0;
            display: flex;
            align-items: flex-end;
            padding: 15px;
            transition: 0.4s;
          }

          .overlay-text {
            color: #fff;
            font-size: 14px;
            font-weight: 600;
          }

          /* HOVER EFFECT */
          .img-box:hover .img {
            transform: scale(1.08);
          }

          .img-box:hover .overlay {
            opacity: 1;
          }

          .img-box:hover {
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          }

          /* ANIMATION */
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* RESPONSIVE */
          @media (max-width: 900px) {
            .img-box {
              height: 220px;
            }
          }
        `}</style>
      </div>
    );
  }
}